<template>
  <v-container>
    <v-layout wrap>
      <v-flex>
        <v-card class="mx-auto my-12 rounded" max-width="600">
          <v-img
            class="white--text align-end"
            rounded
            height="200px"
            src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"
          >
            <v-card-title> About Us - SAASCADETECH</v-card-title>
          </v-img>
          <v-card-subtitle class="black--text">Who we are?</v-card-subtitle>
          <v-card-text class="black--text subtitle-1 font-weight-regular">
            We are a group of young technocrats determined to help small and medium enterprises
            take advantage of technology by offering affordable yet quality
            services which will enable you to compete against the giants. Our
            team has 10+ years of experience of building websites and automating
            various processes which can make your life easier.
          </v-card-text>
        </v-card>

        <v-card class="mx-auto my-12 rounded" max-width="600">
          <v-card-title> Why Us?</v-card-title>
          <v-card-subtitle class="black--text"
            >The SaasCadeTech Advantage</v-card-subtitle  
          >
          <v-card-text class="black--text subtitle-1 font-weight-regular">
            We, at SaasCadeTech, always strive to add value to your every single
            penny, with our experience we know what works in digital world and
            what not,what is essential and what isn't,so feel free to contact
            us,we like to share our knowledge(and yeah ,its free!)
          </v-card-text>
        </v-card>

        <v-card class="mx-auto my-12 rounded" max-width="600">
          <v-card-title> Our Work</v-card-title>
          <v-card-subtitle class="black--text">What we do?</v-card-subtitle>
          <v-card-text class="black--text subtitle-1 font-weight-regular">
            We can help you build a digital presence ,by building your dream
            website/ecommerce or customized applications.We can also help you in
            researching keywords for your business and the market for your
            business online. We can also help you automating stuffs whether be
            it in excel,windows or linux.We also provide managed shared and VPS
            hosting. Please feel free to explore our services.
          </v-card-text>
        </v-card>

        <v-card class="mx-auto my-12 rounded" max-width="600">
          <v-card-title> Roadmap</v-card-title>
          <v-card-subtitle class="black--text"
            >What lies ahead?</v-card-subtitle
          >
          <v-card-text class="black--text subtitle-1 font-weight-regular">
            We are planning to launch managed hosting of most popular FOSS
            softwares and simplest and the cheapest static website builder in
            the near future which can help small and medium enterprises take
            advantage of FOSS and cloud hosting without an IT staff.
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "AboutUs"
};
</script>
